import { render, staticRenderFns } from "./toggle-switch.vue?vue&type=template&id=0dfba333&"
import script from "./toggle-switch.vue?vue&type=script&lang=js&"
export * from "./toggle-switch.vue?vue&type=script&lang=js&"
import style0 from "./toggle-switch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dfba333')) {
      api.createRecord('0dfba333', component.options)
    } else {
      api.reload('0dfba333', component.options)
    }
    module.hot.accept("./toggle-switch.vue?vue&type=template&id=0dfba333&", function () {
      api.rerender('0dfba333', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/input/toggle-switch.vue"
export default component.exports